class PageHome extends DrupalBehavior {

  onContent(context) {
    once('HomepageHero', '.homepage-hero', context).forEach((hero) => {
      if (hero) {
        this.hero = hero;
        this.heroBackground = document.querySelector('.homepage-hero--background');
        this.heroBackgroundImage = document.querySelector('.homepage-hero--background img');
        this.heroTitle = document.querySelector('.homepage-hero--content h1');
        this.heroTimelineTimeout = false;
        this.heroSubtitle = document.querySelector('.homepage-hero--content h2');
        this.heroForm = document.querySelector('.homepage-hero--content form');
        this.heroForm.addEventListener('submit', function(e) {
          e.target.classList.add('submitted');
        });
        this.heroPopularSpecialties = document.querySelector('.homepage-hero--content .popular-specialties-loyal');
        this.heroTimeline = gsap.timeline({ paused: true });
        this.cards = document.querySelectorAll('.featured-cta-cards article');
        this.cardsTimeline = gsap.timeline({ paused: true });
        this.cardsTimeline
              .from(this.cards, { duration: 1.2, ease: 'power4.out', yPercent: 25, opacity: 0, stagger: 0.125 })
        this.mql = window.matchMedia('(max-width: 991px)');
        this.bindEvents();
        this.mql.addListener(this.init);
        this.init(this.mql);
        // window.addEventListener('resize', this.resizeImage);
      }
    });
  }

  bindEvents() {
    this.init = this.init.bind(this);
    // this.resizeImage = this.resizeImage.bind(this);
    this.playHeroAnimation = this.playHeroAnimation.bind(this);
    this.playCardsAnimation = this.playCardsAnimation.bind(this);
  }

  /*
  resizeImage() {
    const heroRatio = this.heroBackground.offsetWidth / this.heroBackground.offsetHeight;
    const imageRatio = this.heroBackgroundImage.width / this.heroBackgroundImage.height;
    let newImageWidth;
    let newImageHeight;
    if (heroRatio > imageRatio) {
      newImageWidth = this.heroBackground.offsetWidth;
      newImageHeight = newImageWidth / imageRatio;
    } else {
      newImageHeight = this.heroBackground.offsetHeight;
      newImageWidth = newImageHeight * imageRatio;
    }
    this.heroBackgroundImage.width = newImageWidth;
    this.heroBackgroundImage.height = newImageHeight;
  }
    */

  init(media) {
    // let img = new Image();
    // img.onload = function() {
    //   this.resizeImage();
    // }.bind(this);
    // img.src = this.heroBackgroundImage.getAttribute('src');
    if (media.matches) {
      this.cardsTimeline.progress(1);
    } else {
      // this.initVideo();
      this.cardsTimeline.progress(1).progress(0);
      setTimeout(this.playCardsAnimation, 200);
    }
    if (this.heroSubtitle) {
      this.heroTimeline
        .fromTo(this.heroTitle,
          {yPercent: 200, opacity: 0},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.2)
        .fromTo(this.heroSubtitle,
          {yPercent: 200, opacity: 0},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.4)
        .fromTo(this.heroForm,
          {yPercent: 100, opacity: 0},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.6)
        .fromTo(this.heroPopularSpecialties,
          {yPercent: 100, opacity: 0},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.8);
    }
    else {
      this.heroTimeline
        .fromTo(this.heroTitle,
          {yPercent: 200, opacity: 0},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.2)
        .fromTo(this.heroForm,
          {yPercent: 100, opacity: 0},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.4)
        .fromTo(this.heroPopularSpecialties,
          {yPercent: 100, opacity: 1},
          {duration: 1.2, ease: 'power4.out', yPercent: 0, opacity: 1},
          0.6);
    }
    this.heroTimeline.progress(1).progress(0);
    if (this.heroTimelineTimeout) {
      window.clearTimeout(this.heroTimelineTimeout);
    }
    this.heroTimelineTimeout = setTimeout(this.playHeroAnimation, 500);
    $(window).trigger('resize');
  }

  initVideo() {
    let videoContainer = document.querySelector('.homepage-hero--background .video');
    if (videoContainer) {
      videoContainer.style.display = 'block';

      const iframe = document.querySelector('.homepage-hero--background iframe');
      const heroImage = document.querySelector('.homepage-hero--background img');
      function sizeVideo() {
        let windowSize = window.outerWidth;
        let newWidth = windowSize + (windowSize * .57);
        let newHeight = newWidth * .36;


        if (navigator.userAgent.match(/iPhone|iPad|iPod/i) && window.matchMedia('(min-width: 991px) and (max-width: 1024px)')) {
          iframe.style.width = '1024px';
          iframe.style.height = '768px';
        }
        else {
          iframe.style.width = newWidth + 'px';
          iframe.style.height = newHeight + 'px';
        }
      }

      sizeVideo();

      window.onresize = sizeVideo;

      iframe.onload = function () {
        gsap.to(heroImage, { duration: 1, ease: 'power4.out', opacity: 0, delay: 1 });
      };

      let videoId = iframe.getAttribute('data-video-id');
      if (/^\d+$/.test(videoId)) {
        let src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&title=0&muted=1&background=1&loop=1';
        iframe.setAttribute('src', src);
      }
    }
  }

  playHeroAnimation() {
    this.hero.classList.add('active');
    this.heroTimeline.play();
  }

  playCardsAnimation() {
    this.cardsTimeline.play();
  }

}

DrupalBehavior.register('summit_theme.pages', 'home', PageHome);
